import React from 'react';
import { getTournamentLogoUrl, ManageTournament } from '../api/tournament/manageTournamentService';
import './TournamentHeader.css';

interface TournamentHeaderProps {
  tournament: ManageTournament | null;
  onGoBack: () => void;
  showBackButton?: boolean;
}

const TournamentHeader: React.FC<TournamentHeaderProps> = ({
  tournament,
  onGoBack,
  showBackButton = true
}) => {
  return (
    <div className="page-header-section mb-4" style={{ position: 'relative', zIndex: 10 }}>
      {/* Row 1: Back Button, Tournament Logo, Tournament Name - Left Aligned */}
      <div className="d-flex align-items-center mb-4" style={{ gap: '16px', position: 'relative', zIndex: 10, marginBottom: '24px !important', justifyContent: 'flex-start', width: '100%' }}>
        {showBackButton && (
          <button 
            className="back-button"
            onClick={onGoBack}
            style={{ position: 'relative', zIndex: 10 }}
          >
            <i className="ri-arrow-left-line"></i>
          </button>
        )}
        <div className="tournament-logo-small" style={{ flexShrink: 0, position: 'relative', zIndex: 10 }}>
          {tournament?.logo ? (
            <img 
              src={getTournamentLogoUrl(tournament) || ''}
              alt="Tournament Logo" 
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                target.nextElementSibling?.classList.remove('d-none');
              }}
            />
          ) : null}
          {!tournament?.logo && (
            <div className="default-tournament-logo-small">
              <i className="ri-trophy-line"></i>
            </div>
          )}
        </div>
        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
          <h1 className="page-title mb-0" style={{ position: 'relative', zIndex: 10 }}>{tournament?.name}</h1>
          {tournament?.shortName && (
            <div className="d-flex align-items-center" style={{ gap: '4px' }}>
              <span className="tournament-short-name-badge">{tournament.shortName}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TournamentHeader;
